import { render, staticRenderFns } from "./ITextArea.vue?vue&type=template&id=17c21e2d"
import script from "./ITextArea.vue?vue&type=script&lang=ts"
export * from "./ITextArea.vue?vue&type=script&lang=ts"
import style0 from "./ITextArea.vue?vue&type=style&index=0&id=17c21e2d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports